import {Dialog, DialogOverlay, DialogPortal} from '@radix-ui/react-dialog';
import {Text} from '@travel-frontend/core';
import {IllustrationTimeout} from '@travel-frontend/illustrations';
import {Button} from '@travel-frontend/ui-components';
import {useTranslation} from 'react-i18next';

import {
  Backdrop,
  Content,
  CustomDialogBody,
  CustomDialogHead,
} from '@/components/InactivityLayer/components';

type Props = React.PropsWithChildren<{
  open: boolean;
  onUpdateBtnClick?: () => void;
}>;

export const InactivityLayer: React.FunctionComponent<Props> = ({
  open,
  onUpdateBtnClick,
}) => {
  const {t} = useTranslation('general');

  return (
    <Dialog open={open} modal>
      <DialogPortal container={document.getElementById('portal-root')}>
        <Backdrop open={open} />
        <DialogOverlay>
          <Content>
            <CustomDialogHead>
              <IllustrationTimeout width={200} height={200} />
            </CustomDialogHead>
            <CustomDialogBody>
              <Text preset="headlineLarge" align="center">
                {t('inactivityLayer.title')}
              </Text>
              <Text
                preset="paragraphMedium"
                align="center"
                color="contentSecondary"
              >
                {t('inactivityLayer.text')}
              </Text>
              <Button fullWidth onClick={onUpdateBtnClick}>
                {t('inactivityLayer.buttonName')}
              </Button>
            </CustomDialogBody>
          </Content>
        </DialogOverlay>
      </DialogPortal>
    </Dialog>
  );
};
